"use client";

import React from 'react';
import { useComingSoon } from '../../context/ComingSoonContext';

const DiscountButton = ({ onClick }) => {
  const { hasSubmitted } = useComingSoon();
  
  const handleClick = () => {
    // Track button click with Google Analytics
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'button_click', {
        'event_category': 'engagement',
        'event_label': 'Get Launch Discount Button'
      });
    }
    
    // Call the original onClick handler
    if (onClick) {
      onClick();
    }
  };

  // If user has already submitted, show static "Coming Soon" text
  if (hasSubmitted) {
    return (
      <div className="
        bg-gray-200 text-gray-700
        font-bold text-sm md:text-base
        py-1.5 px-3 md:py-2.5 md:px-4
        rounded-full
        flex items-center gap-1 md:gap-2
        border md:border-2 border-white
      ">
        <span className="inline-block">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-4 w-4 md:h-5 md:w-5 text-gray-500" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={1.5}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
            />
          </svg>
        </span>
        <span>Coming Soon</span>
      </div>
    );
  }

  // Regular discount button for users who haven't submitted
  return (
    <button
      onClick={handleClick}
      className="
        bg-primary hover:bg-primary-dark text-white 
        font-bold text-sm md:text-base
        py-1.5 px-3 md:py-2.5 md:px-4
        rounded-full shadow-md hover:shadow-lg
        transition-all duration-300 ease-in-out 
        animate-pulse hover:animate-none
        transform hover:scale-105
        flex items-center gap-1 md:gap-2
        border md:border-2 border-white
      "
    >
      {/* Discount tag icon */}
      <span className="inline-block animate-wiggle">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          className="h-4 w-4 md:h-5 md:w-5 text-yellow-300" 
          fill="currentColor" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={1} 
            d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" 
          />
        </svg>
      </span>
      
      <span className="relative">
        Get Launch Discount
      </span>
      
      {/* Arrow icon */}
      <span className="inline-block">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          className="h-4 w-4 md:h-5 md:w-5 text-yellow-300 animate-wiggle" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M13 7l5 5m0 0l-5 5m5-5H6" 
          />
        </svg>
      </span>
    </button>
  );
};

export default DiscountButton; 